import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Logo } from './Logo';
const FOOTER_LINKS = [{
  label: 'Privacy Policy',
  href: '/privacy'
}, {
  label: 'Terms',
  href: '/terms'
}, {
  label: 'Website Disclaimer',
  href: '/disclaimer'
}, {
  label: 'Accessibility',
  href: '/accessibility'
}, {
  label: 'Contact',
  href: '/contact'
}, {
  label: 'Sitemap',
  href: '/sitemap'
}];
const SERVICE_LINKS = [{
  label: 'Buying property',
  href: '/buying-property'
}, {
  label: 'Selling property',
  href: '/selling-property'
}, {
  label: 'Contract review',
  href: '/contract-review'
}, {
  label: 'SMSF & trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial property',
  href: '/commercial-property'
}, {
  label: 'Property transfers',
  href: '/property-transfers'
}];
export function Footer() {
  return <footer className="bg-ink text-cream pt-10 pb-20 md:pb-10" data-id="element-407" data-mp="2kcl3h90pilw6">
      <div className="max-w-7xl mx-auto px-5 md:px-6" data-id="element-408" data-mp="2kba1neqtno7p">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8 mb-8" data-id="element-409" data-mp="2p4uyv4klce5u">
          <div className="md:col-span-4 space-y-5" data-id="element-410" data-mp="2bd7sud0ujr9v">
            <Logo inverted size="xl" className="-ml-2" data-id="element-411" data-mp="2babw2s0qj8n0" />
            <p className="text-cream/65 leading-relaxed max-w-sm" data-id="element-412" data-mp="2gckrrw4zsost">
              Lawyer-led conveyancing and property law for Australian buyers,
              sellers and investors, based in Melbourne.
            </p>
          </div>

          <nav className="md:col-span-4" aria-label="Services" data-id="element-413" data-mp="381w7czdcswej">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/45 mb-5" data-id="element-414" data-mp="2u1uxiuf42emx">
              Services
            </h3>
            <ul className="space-y-3 text-[15px]" data-id="element-415" data-mp="2z43sfwbjnqro">
              {SERVICE_LINKS.map(link => <li key={link.label} data-id="element-416" data-mp="1ipu4h3b7s41d">
                  <Link to={link.href} className="text-cream/80 hover:text-accent-light transition-colors" data-id="element-417" data-mp="1nndgrxocq6qo">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="md:col-span-4" data-id="element-418" data-mp="us5zcox4m3j1">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/45 mb-5" data-id="element-419" data-mp="ur4iu4xccotx">
              Visit & contact
            </h3>
            <address className="not-italic text-cream/80 space-y-4 text-[15px]" data-id="element-420" data-mp="ku8bw3n3carh">
              <p className="flex items-start gap-3" data-id="element-421" data-mp="ks5aknghmv7g">
                <MapPin className="w-4 h-4 mt-1 text-accent-light shrink-0" data-id="element-422" data-mp="fu3r41f5gtvg" />
                <span data-id="element-423" data-mp="bt1pxf1oa7qu">
                  202 Elgin Street
                  <br data-id="element-424" data-mp="bvnwpcgqoj80" />
                  Carlton VIC 3053, Australia
                </span>
              </p>
              <p className="flex items-center gap-3" data-id="element-425" data-mp="6wtg8h68v6r2">
                <Phone className="w-4 h-4 text-accent-light shrink-0" data-id="element-426" data-mp="266jhre941qro" />
                <a href="tel:+61386172600" className="hover:text-accent-light transition-colors" data-id="element-427" data-mp="217yfzae7mz14">
                  (03) 8617 2600
                </a>
              </p>
              <p className="flex items-center gap-3" data-id="element-428" data-mp="2dq27028y6g8p">
                <Mail className="w-4 h-4 text-accent-light shrink-0" data-id="element-429" data-mp="2dor5ya6vzmla" />
                <a href="mailto:hello@lapropertylaw.com.au" className="hover:text-accent-light transition-colors" data-id="element-430" data-mp="2iilvvvd34xst">
                  hello@lapropertylaw.com.au
                </a>
              </p>
              <p className="flex items-start gap-3" data-id="element-431" data-mp="1urpvi9ukcu9y">
                <Clock className="w-4 h-4 mt-1 text-accent-light shrink-0" data-id="element-432" data-mp="1ushrvmvziw1a" />
                <span data-id="element-433" data-mp="1zqjcic9273ev">
                  Mon-Fri 9:00am-5:00pm
                  <br data-id="element-434" data-mp="23snzis5051sj" />
                  Office visits by appointment only
                </span>
              </p>
              <p className="pt-1" data-id="element-435" data-mp="3b79871fuwcu8">
                <a href="https://maps.google.com/?q=202+Elgin+Street,+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-accent-light hover:text-white underline underline-offset-4" data-id="element-436" data-mp="3b67z32iei0f5">
                  View on Google Maps
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col lg:flex-row justify-between gap-5" data-id="element-437" data-mp="3iph7otj31v35">
          <div className="space-y-2 max-w-3xl text-xs text-cream/45 leading-relaxed" data-id="element-438" data-mp="jm3ho0b937p">
            {/* Footer legal wording needs legal review before launch. */}
            <p data-id="element-439" data-mp="3rouh5m77ijnv">
              Liability limited by a scheme approved under Professional
              Standards Legislation.
            </p>
            <p data-id="element-440" data-mp="5auf8qp450o1">
              The information on this website is general information and is not
              legal advice. Legal advice should be obtained for your particular
              circumstances.
            </p>
          </div>

          <ul className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-cream/60 shrink-0 h-fit" data-id="element-441" data-mp="fb4q44nodw01">
            {FOOTER_LINKS.map(link => <li key={link.label} data-id="element-442" data-mp="12wf2pm4mqvzt">
                <Link to={link.href} className="hover:text-accent-light transition-colors" data-id="element-443" data-mp="12vdt7m39ihk7">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        <p className="mt-5 text-xs text-cream/35" data-id="element-444" data-mp="f7cm8hlqf96w">
          &copy; {new Date().getFullYear()} L.A Property Law & Conveyancing.
        </p>
      </div>
    </footer>;
}